import { useState } from 'react';
import { useEclipsePanorama } from '../../../hooks';
import { useCurrentModule } from '../../ModuleProvider';
export const useInitSuccess = () => {
  const [didInitSuccess, setDidInitSuccess] = useState(false);
  const [eventAggregator, setEventAggregator] = useState(undefined);
  const panorama = useEclipsePanorama();
  const module = useCurrentModule();
  const handleInitSuccess = orderPageEventAggregator => {
    if (!didInitSuccess) {
      panorama.finishTransaction('checkout-page-load', {
        eventAggregator: orderPageEventAggregator
      });
      module.internals.bi.onCheckoutPageLoad == null || module.internals.bi.onCheckoutPageLoad({
        eventAggregator: orderPageEventAggregator
      });
    }
    setEventAggregator(orderPageEventAggregator);
    setDidInitSuccess(true);
  };
  return {
    eventAggregator,
    handleInitSuccess,
    didInitSuccess
  };
};
//# sourceMappingURL=useInitSuccess.js.map